import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AvailabilityStatusEnum } from 'server/shared/models/availabilityStatusEnum';
import { ShiftEnum } from 'server/shared/models/shift.enum';
import { UserAvailability } from 'server/shared/models/userAvailability';
export type ShiftToggleEvent = {
  shift: ShiftEnum;
  available?: boolean;
};

@Component({
  selector: 'app-availability-shift-toggle-list',
  templateUrl: './availability-shift-toggle-list.component.html',
  styleUrls: ['./availability-shift-toggle-list.component.scss'],
})
export class AvailabilityShiftToggleListComponent {
  shiftEnum = ShiftEnum;
  availabilityStatusEnum = AvailabilityStatusEnum;
  @Input() availability?: UserAvailability;
  @Output() shiftToggled = new EventEmitter<ShiftToggleEvent>();
  @Input() disabled: boolean = false;
}
